/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined';
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined';
import LocalPlayOutlinedIcon from '@material-ui/icons/LocalPlayOutlined';
import LocalShippingIcon from '@material-ui/icons/LocalShippingOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import WorkOutlineOutlinedIcon from '@material-ui/icons/WorkOutlineOutlined';
import LiveTvOutlinedIcon from '@material-ui/icons/LiveTvOutlined';
import GroupsOutlinedIcon from '@material-ui/icons/GroupOutlined';
import AddAlertOutlinedIcon from '@material-ui/icons/AddAlertOutlined';
import LiveHelpOutlinedIcon from '@material-ui/icons/LiveHelpOutlined';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import ReceiptIcon from '@material-ui/icons/Receipt';
import PictureInPicture from '@material-ui/icons/PictureInPicture';
import './navbar.css';

export default [
  {
    subheader: 'Account & Dashboard',
    items: [
      // SPEC_MCP:NAV
      {
        title: 'Account Overview',
        href: '/overview',
        icon: PersonOutlineIcon,
        roles: [],
      },
    ],
  },
  {
    subheader: 'CLASS MANAGEMENT',
    items: [
      {
        title: 'Scheduling',
        href: '/live-classes',
        icon: LiveTvOutlinedIcon,
        roles: ['SUPER_ADMIN', 'INSTRUCTOR', 'SCHEDULER', 'SCHEDULER_MANAGER'],
      },
      {
        title: 'Batch Management',
        href: '/batch-management',
        icon: GroupsOutlinedIcon,
        roles: ['SUPER_ADMIN', 'SCHEDULER'],
      },
      {
        title: 'Group Management',
        href: '/group-management',
        icon: GroupsOutlinedIcon,
        roles: ['SUPER_ADMIN', 'SCHEDULER'],
      },
    ],
  },
  {
    subheader: 'subjects & courses',
    items: [
      {
        title: 'Subject Management',
        href: '/subject-management',
        icon: LayersOutlinedIcon,
        roles: ['SUPER_ADMIN', 'CONTENT_ADMIN', 'CONTENT_DEVELOPER'],
        items: [
          {
            title: 'Subject Management',
            href: '/subject-management',
            // icon: LayersOutlinedIcon,
            roles: ['SUPER_ADMIN', 'CONTENT_ADMIN', 'CONTENT_DEVELOPER'],
          },
          {
            title: 'Subject Review',
            href: '/subject-review',
            // icon: RateReviewIcon,
            roles: ['SUPER_ADMIN', 'CONTENT_ADMIN'],
          },
        ],
      },
      {
        title: 'Publish Courses',
        href: '/publisher',
        icon: SendOutlinedIcon,
        roles: ['SUPER_ADMIN', 'PUBLISHER', 'CONTENT_ADMIN'],
        items: [
          {
            title: 'Catalogue Manager',
            href: '/publisher/catalogueManager/catalogueList',
            // icon: NearMeIcon,
            roles: ['SUPER_ADMIN', 'PUBLISHER'],
          },
          {
            title: 'Store Manager',
            href: '/publisher/storeManager/storeDetailsList',
            // icon: NearMeIcon,
            roles: ['SUPER_ADMIN', 'PUBLISHER'],
          },
          {
            title: 'Navigation Manager',
            href: '/publisher/navigationManager/menu',
            roles: ['SUPER_ADMIN', 'CONTENT_ADMIN'],
          },
        ],
      },
      {
        title: 'File Management',
        href: '/file-management',
        icon: FolderOutlinedIcon,
        roles: ['SUPER_ADMIN', 'CONTENT_ADMIN', 'CONTENT_DEVELOPER', 'CONTENT_UPLOADER'],
        items: [
          {
            title: 'File Explorer',
            href: '/file-explorer',
            // icon: PermMediaIcon,
            roles: ['SUPER_ADMIN', 'CONTENT_ADMIN', 'CONTENT_DEVELOPER', 'CONTENT_UPLOADER'],
          },
          {
            title: 'Transcoding Manager',
            href: '/transcoding-manager',
            // icon: MovieIcon,
            roles: ['SUPER_ADMIN', 'CONTENT_ADMIN', 'CONTENT_DEVELOPER', 'CONTENT_UPLOADER'],
          },
        ],
      },
    ],
  },
  {
    subheader: 'sales management',
    items: [
      {
        title: 'Coupon Management',
        href: '/coupons',
        icon: LocalPlayOutlinedIcon,
        roles: ['SUPER_ADMIN', 'SALES_ADMIN', 'SALES_MANAGER', 'SALES_EXECUTIVE'],
      },
      {
        title: 'Delivery Management',
        href: '/deliveryManagement',
        icon: LocalShippingIcon,
        roles: ['SUPER_ADMIN', 'DELIVERY_MANAGER'],
      },
      {
        title: 'Hall Tickets & Scholarships',
        icon: LocalOfferOutlinedIcon,
        href: '/scholarships/',
        roles: ['SUPER_ADMIN', 'SALES_ADMIN', 'SALES_MANAGER', 'SALES_EXECUTIVE'],
      },
      {
        title: 'Marketing Campaigns',
        icon: () => (
          <img
            src="images/marketing-icon.png"
            alt="marketing"
            height={24}
            width={24}
            style={{ marginRight: '.5rem' }}
          />
        ),
        href: '/marketing/',
        roles: ['SUPER_ADMIN', 'SALES_ADMIN', 'SALES_MANAGER', 'DIGITAL_MARKETER'],
      },
    ],
  },
  {
    subheader: 'Student Management',
    items: [
      {
        title: 'Student Support',
        href: '/student-management',
        icon: LiveHelpOutlinedIcon,
        roles: ['SUPPORT_MANAGER', 'SUPPORT_ADMIN', 'SUPER_ADMIN'],
      },
      {
        title: 'Student Updates',
        href: '/student-updates/GENERAL',
        icon: AddAlertOutlinedIcon,
        roles: ['UPDATE_MANAGER'],
      },
      {
        title: 'Payments & Invoices',
        href: '/payment-invoices',
        icon: ReceiptIcon,
        roles: ['FINANCE_ADMIN', 'SUPER_ADMIN'],
      },
    ],
  },
  {
    subheader: 'MISCellaneous',
    items: [
      {
        title: 'User Management',
        href: '/user-management',
        icon: WorkOutlineOutlinedIcon,
        roles: ['SUPER_ADMIN', 'USER_MANAGER'],
      },
      {
        title: 'Seo Manager',
        href: '/seo-manager',
        icon: () => (
          <img
            src="images/seo_icon.png"
            alt="search engine optimization"
            height={24}
            width={24}
            style={{ marginRight: '.5rem' }}
          />
        ),
        roles: ['SALES_ADMIN'],
      },
      {
        title: 'Legal Notices',
        href: '/legal',
        icon: PictureAsPdfOutlinedIcon,
        roles: ['SUPER_ADMIN'],
      },
      {
        title: 'Faculty Reports',
        href: '/faculty-reports',
        icon: () => (
          <img
            width={20}
            height={20}
            style={{ marginRight: '.25rem' }}
            src="/images/chart-pie.svg"
            alt="Facult Reports Section"
          />
        ),
      },
      {
        title: 'Banner Update',
        href: '/banner-update',
        icon: PictureInPicture,
        roles: ['SUPER_ADMIN', 'SALES_ADMIN'],
        items: [
          {
            title: 'Website Banner Update',
            href: '/web-banner',
            roles: ['SUPER_ADMIN', 'SALES_ADMIN'],
          },
          {
            title: 'Mobile Banner Update',
            href: '/mobile-banner',
            roles: ['SUPER_ADMIN', 'SALES_ADMIN'],
          },
        ],
      },
    ],
  },
];
